module.exports = __webpack_public_path__ + "media/honey-icons/icon-fullscreen-a20d54f9.svg";